export class WbProduct {
  constructor() {
    this.init();
  }

  init() {
    return new Promise((resolve, reject) => {
      this.bindListeners();
      resolve();
    });
  }

  bindListeners() {
    const _this = this;
    document
      .querySelector('body')
      ._addCustomEventListener(
        'click',
        '.wb-variant-list__variant',
        _this.clickOnVariant.bind(_this),
      );
    document
      .querySelector('body')
      ._addCustomEventListener(
        'click',
        '.wb-variant-list__add-wishlist',
        _this.updateWishlist.bind(_this),
      );
  }

  clickOnVariant(e) {
    const ele = e?.targetElement;
    const othersVariantEle = document.querySelectorAll('.wb-variant-list__variant');
    othersVariantEle?.forEach(otherVariant => {
      otherVariant.classList?.remove('--active');
    });
    ele?.classList.add('--active');
    const {
      title = '',
      variantId = '00000',
      sku = '0000',
      mainImage = '',
      mainImageSrcset = '',
      colorImage = '',
      colorImageSrcset = '',
      serie = '',
      serieSlug = '',
    } = ele.dataset;
    const variantInfoElement = document.querySelector('.wb-variant-list__selected-variant-title');
    const serieInfoElement = document.querySelector('.wb-variant-list__selected-serie');
    const productImage = document.querySelector('.wb-product-heading__image');
    const wishListForm = document.querySelector('.wb-variant-list__form');
    this.hideMessageBoxes();
    const elementId = wishListForm?.querySelector('input[name="elementId"]');
    if (elementId) {
      elementId.value = variantId;
    }
    if (variantInfoElement) {
      variantInfoElement.textContent = title;
    }
    if (serieInfoElement) {
      serieInfoElement.textContent = serie;
      serieInfoElement.setAttribute('data-serie', serieSlug);
    }
    if (productImage) {
      if (mainImage) {
        productImage.querySelector('.wb-product-heading__image__el')?.setAttribute('src', mainImage);
        productImage.querySelector('.wb-product-heading__image__el')?.setAttribute('srcset', mainImageSrcset);
        productImage.querySelector('.wb-product-heading__image__el')?.setAttribute('title', title);
        productImage.querySelector('.wb-product-heading__image__el')?.setAttribute('alt', title);
      }

      if (colorImage) {
        productImage.querySelector('.wb-product-heading__variant-img')?.setAttribute('src', colorImage);
        productImage.querySelector('.wb-product-heading__variant-img')?.setAttribute('srcset', colorImageSrcset);
        productImage.querySelector('.wb-product-heading__variant-img')?.setAttribute('title', title);
        productImage.querySelector('.wb-product-heading__variant-img')?.setAttribute('alt', title);
      }
    }
  }

  hideMessageBoxes() {
    document.querySelectorAll('.wb-variant-list__error')?.forEach(el => {
      el.classList.add('d-none');
    });
    document.querySelectorAll('.wb-variant-list__added')?.forEach(el => {
      el.classList.add('d-none');
    });
  }

  updateWishlist(e) {
    e.preventDefault();
    document.querySelectorAll('wb-variant-list__error')?.forEach(el => {
      el.innerHTML = '';
      el.classList.add('d-none');
    });

    const form = e.target.parentElement;
    if (form) {
      const data = new FormData(form);
      const addedBox = form.querySelector('.wb-variant-list__added');
      const addingBox = form.querySelector('.wb-variant-list__adding');
      const errorBox = form.querySelector('.wb-variant-list__error');
      errorBox?.classList.add('d-none');
      addingBox?.classList.remove('d-none');

      fetch('/', {
        method: 'post',
        body: data,
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      }).then(function(response) {
        response.json().then(function(data) {
          addingBox.classList.add('d-none');
          if (data.error) {
            errorBox?.classList.remove('d-none');
          } else {
            addedBox?.classList.remove('d-none');
          }
        });
      });
    }

  }
}
